// src/context/AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { auth } from "../firebase";

const AuthContext = createContext(null);

/** Firebase error codes are not readable — map the ones a real admin hits. */
const MESSAGES = {
  "auth/invalid-email": "Email-i nuk është i saktë.",
  "auth/user-not-found": "Kjo llogari nuk ekziston.",
  "auth/wrong-password": "Fjalëkalimi është gabim.",
  "auth/invalid-credential": "Email-i ose fjalëkalimi është gabim.",
  "auth/too-many-requests":
    "Shumë provë të dështuara. Prisni pak dhe provoni sërish.",
  "auth/network-request-failed": "Nuk ka lidhje me internetin.",
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(
    () =>
      onAuthStateChanged(auth, (u) => {
        setUser(u);
        setLoading(false);
      }),
    [],
  );

  const login = async (email, password) => {
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      return { ok: true };
    } catch (err) {
      return {
        ok: false,
        message: MESSAGES[err.code] || "Kyçja dështoi. Provoni përsëri.",
      };
    }
  };

  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
};
